<template lang="html">

  <article class="col-33" v-if="!!data">
    <a class="clipping-item" :href="server+data.archivo" download target="_blank">
      <div>
        <img :src="server+data.miniatura" alt="">
      </div>
      <p v-html="data.titulo"></p>
    </a>
  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'pressroom-el',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
     ...mapGetters({
      lang: 'getLanguage',
      server : 'getServer'
    })
   }
 }
</script>

<style scoped>
article{
  padding: 0 15px;
  width: 33.333333333%;
}


article div{
  text-align: center;
}
img{
  max-width: 100%;
  max-height: 100%;
  display: inline-block;
}

@media screen and (max-width: 768px){
  article{
    width: 50%;
  }
}

@media screen and (max-width: 460px){
  article{
    width: 100%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/parts/pressroom-el.vue